<template>
    <div class="modal fade" id="edit_module_modal" tabindex="-1" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content" v-if="module">
                <div class="modal-header">
                    <h5 class="modal-title">{{ module.name + $lang(' - edycja') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="value">{{ module.module.type.showable_name }}</label>
                        <template v-if="selectedType.kind==='boolean'">
                            <div class="form-check">
                                <input type="radio" id="yes" name="value" value="1"
                                       v-model.number="value"/>
                                <label for="yes">{{ $lang('Tak') }}</label>

                                <input type="radio" id="no" name="value" value="0"
                                       v-model.number=value class="ml-2"/>
                                <label for="no">{{ $lang('Nie') }}</label>
                            </div>
                        </template>
                        <template v-else>
                            <input id="value" type="number" min="0" name="value" class="form-control"
                                   v-model.number="value"/>
                        </template>
                    </div>

                    <div class="form-group">
                        <input type="checkbox" name="extend" id="extend" v-model="extend" class="ml-1"/>
                        <label for="extend">{{ $lang('Przedłuż o rok') }}</label>
                        <datepicker-accessible
                            :label-single="$lang('Data wygaśnięcia')"
                            custom-id="expired"
                            name="expired"
                            mode="date"
                            :use_pencil_checkbox="false"
                            :strong_label="false"
                            :hidden="extend"
                            v-model="expired"
                        ></datepicker-accessible>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">
                        {{ $lang('Zamknij') }}
                    </button>
                    <button @click="edit" type="button" class="btn btn-primary" :disabled="valid" data-dismiss="modal">
                        {{ $lang('Zapisz') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "library-module-edit",
    props: {
        url: String,
        module: Object,
        trade_module_types: Array,
    },
    data() {
        return {
            id: (this.module != null ? this.module.id : ''),
            value: (this.module != null ? this.module.value : ''),
            expired: (this.module != null ? this.module.expired : ''),
            extend: false,
            selectedType: null,
        }
    },
    methods: {
        edit: function () {
            const self = this;
            axios.post(this.url, {
                id: this.id,
                value: this.value,
                expired: this.expired,
                extend: this.extend
            })
                .then(function () {
                    self.$parent.getUserModules();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getType(id) {
            if (typeof this.trade_module_types !== 'undefined') {
                for (const type of this.trade_module_types) {
                    if (type.id === id) {
                        return type;
                    }
                }
            }
            return 0;
        },
    },
    computed: {
        valid() {
            return !(this.value !== '')
        }
    },
    watch: {
        module: {
            deep: true,
            handler() {
                if (this.module !== null) {
                    this.id = this.module.id;
                    this.value = this.module.value;
                    this.expired = this.module.expired;
                    this.selectedType = this.getType(this.module.type_id);
                }
            }
        }
    }
}
</script>
